/* tslint:disable */
import {observable} from 'mobx'
import {observer} from 'mobx-react'
import * as React from 'react'
import {MutationFunction} from '@apollo/client'
import {RouteComponentProps, withRouter} from 'react-router'
import {isAndroid} from 'react-device-detect'
import {Button} from '../../atoms/Button'
import {IntakeStepContainer} from '../../atoms/IntakeStepContainer'
import {IntakeProgressBar} from '../../molecules/IntakeProgressBar/index'
import {
  GetOwnIntakeQuery,
  GetOwnIntakeQuery_getOwnIntake,
  UpdateOwnIntakeMutation,
  UpdateOwnIntakeMutationVariables,
} from '../../schema/schemaTypes'
import {getIntakeStepId} from '../../utils/getIntakeStepId'
import {jump} from '../../utils/scrollFn'
import {IIntakeStep} from './IIntakeStep'

import {Dots} from 'react-activity';
import 'react-activity/dist/react-activity.css';
import styled from 'styled-components'
import {GET_OWN_INTAKE_QUERY} from '../../queries/GET_OWN_INTAKE_QUERY'


interface IProps extends RouteComponentProps {
  steps: IIntakeStep[]
  intake: GetOwnIntakeQuery_getOwnIntake
  nextPage: string
  updateOwnIntake: MutationFunction<UpdateOwnIntakeMutation, UpdateOwnIntakeMutationVariables>
}

const createComponent = (Component: any) =>
class LoadingDots extends React.Component<any, any> {
  constructor(props: any) {
    super(props)
  }

  async handleSubmit(vars: any, goToNext = true) {
      this.props.handleSubmit(vars, goToNext)
  }

  public render() {
    return (
      <div>
        <Component {...this.props}
                   handleSubmit={(variables: any, goNext = true) => this.handleSubmit(variables, goNext)}/>
        <div style={{height: 30}}/>
      </div>
    )
  }

}

@observer
class IntakeManagerInner extends React.Component<IProps> {
  @observable private currentIndex = 0
  private currentFieldValue = null

  state = {}

  public componentWillMount() {
    this.currentIndex = this.getIndexOfFirstIncomplete(this.props.intake)

    // @ts-ignore
    window.myhelp = this
    // @ts-ignore
    window.jump = jump
  }

  public componentDidMount() {
    this.transitionTo(this.currentIndex)
  }

  public goToPrev = (cache: GetOwnIntakeQuery_getOwnIntake | null) => () => {
    // check if a
    this.goToIndex(this.currentIndex - 1, cache)
  }

  public goToNext = (cache: GetOwnIntakeQuery_getOwnIntake | null) => () => {
    // check if a
    this.goToIndex(this.currentIndex + 1, cache)
  }

  public goToIndex = (index: number, cache: GetOwnIntakeQuery_getOwnIntake | null) => {
    this.currentFieldValue = null
    // tslint:disable-next-line:no-console
    if (index < 0) {
      this.transitionTo(0)
      return
    }

    // check if desired no exists, if no handle submit
    if (index >= this.props.steps.length) {


      const currentPage = window.location.href.replace(/^.*\//,'')

      if (currentPage === 'intake-2') {
        // @ts-ignore
        window.handleStepSubmit()
      }

      this.props.history.push(this.props.nextPage)
      return
    }

    // check if intake step at any previous index is incomplete, if yes jump back
    const indexOfFirstIncomplete = this.getIndexOfFirstIncomplete(cache || this.props.intake)

    if (indexOfFirstIncomplete <= index) {
      this.transitionTo(indexOfFirstIncomplete)
      return
    }

    this.transitionTo(index)
  }

  public handleSubmit = async (vars: UpdateOwnIntakeMutationVariables, goToNext = true) => {
    if (Object.keys(vars).length > 0) {
      const currentIndex = this.currentIndex
      const keys = Object.keys(vars)
      await this.setState(keys.reduce((a, b) => (a[b] = true, a), {}))
      // @ts-ignore
      await this.props.updateOwnIntake({
        variables: vars,
        optimisticResponse: {
          updateIntake: {
            __typename: this.props.intake.__typename,
            id: this.props.intake.id,
            ...this.props.intake,
            ...vars,
          },
        },
        update: async (proxy, {data}) => {
          // data.
          // Read the data from our cache for this query.
          let cacheData = proxy.readQuery({query: GET_OWN_INTAKE_QUERY}) as GetOwnIntakeQuery;
          // Add our comment from the mutation to the end.
          const intake = {
            ...cacheData!.getOwnIntake!,
            ...data!.updateIntake
          }

          if(intake){
            //cacheData.getOwnIntake = intake
          }

          // Write our data back to the cache.
          proxy.writeQuery({query: GET_OWN_INTAKE_QUERY, data: cacheData});

          if (goToNext && currentIndex === this.currentIndex) {
            this.goToNext(cacheData.getOwnIntake!)()
          }
        },
      })
      await this.setState(keys.reduce((a, b) => (a[b] = undefined, a), {}))
    } else if (goToNext) {
      this.goToNext(null)()
    }
  }

  public render() {
    const { intake, steps } = this.props
    const isLoading = this.isLoading()
    return (
      <>
        {steps.map(({Component, completed, ...rest}, i) => {
          const NewComponent: any = createComponent(Component)

          return (
            <NewComponent
              {...rest}
              key={i}
              id={getIntakeStepId(i)}
              active={this.currentIndex === i}
              activeValue={this.currentFieldValue}
              intake={intake}
              onChange={this.handleFieldChange}
              isCompleted={completed(intake)} no={i + 1} currentIndex={this.currentIndex}
              handleSubmit={this.handleSubmit}
            />
          )
        })}
        <IntakeStepContainer active={this.currentIndex === steps.length - 1}
                             style={{textAlign: 'center', marginBottom: 40}}>
          <Button
            style={{marginBottom: isAndroid ? '60%' : 40}}
            disabled={
              isLoading ||
              this.currentIndex !== steps.length - 1 ||
              (steps[steps.length - 1].name === 'painMedsExpressCryingWhining' &&
                !steps[steps.length - 1].completed(intake)
              )
            } onClick={this.goToNext(null)}>
            {isLoading ? <Dots/> : (process.env.REACT_APP_LANGUAGE === 'es' ? 'SOMETER' : 'SUBMIT')}
          </Button>

        </IntakeStepContainer>
        <IntakeProgressBar currentIndex={this.currentIndex} count={steps.length}
          goToNext={this.goToNext(null)} goToPrev={this.goToPrev(null)} />
      </>
    )
  }

  private handleFieldChange = (newValue: any) => {
    this.currentFieldValue = newValue
  }

  private isLoading(): boolean {
    return Object.values(this.state).reduce((value, isLoading) => (isLoading || value), false) as boolean
  }

  private transitionTo = (index: number) => {
    this.currentIndex = index
    // this offset should match intakeScaleBar
    // note: 150 = 65 (height ot header) + 70 (height of child information bar) + extra (to give question padding on top)
    let offset = -260

    const currentPage = window.location.href.replace(/^.*\//,'')

    // if intake page, need to determine whether to add offset for intake scale bar
    if (currentPage === 'intake-1') {
      let scaleBarOffset = 0
      if ( index >= 7  && index <= 12 ) { scaleBarOffset = document.querySelector('#intake-scale-1')!.getBoundingClientRect().height }
      else if ( index >= 18 && index <= 28 ) { scaleBarOffset = document.querySelector('#intake-scale-2')!.getBoundingClientRect().height }

      offset -= scaleBarOffset
    }

    jump('#' + getIntakeStepId(this.currentIndex), {
      duration: 300,
      offset,
    })
  }

  private getIndexOfFirstIncomplete = (data: GetOwnIntakeQuery_getOwnIntake) => {
    for (let i = 0; i < this.props.steps.length; i++) {
      const step = this.props.steps[i]
      if (!step.completed(data)) {
        return i
      }
    }
    // return last
    return this.props.steps.length - 1
  }
}

const DotContainer = styled.div`
@media (min-width: 768px) {
  margin-left: 50px;
}
`


export const IntakeManager = withRouter(IntakeManagerInner)



// WEBPACK FOOTER //
// ./src/organisms/Intakes/IntakeManager.tsx